// extracted by mini-css-extract-plugin
export default {"rows":"user-details-card_rows__sqhoc"};